<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/yongxin/energy/consumption/alarm/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select multiple type="equipment" :placeholder="$t('suoyoushebei')" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('tongjikaishishijian')">
            <yi_time_input format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" type="datetimerange" :start.sync="yt.conditions.start" :end.sync="yt.conditions.end"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shifouchaochushangxiaxian')">
            <el-select v-model="yt.conditions.exceedLimit" clearable :placeholder="$t('qingxuanze')">
              <el-option v-for="item in exceedLimit" :key="item.value" :label="$t(item.label)" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="reset">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL> </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #meixiaoshibiaozhunhaodianxiaxian="scope">
        <span>{{ scope.row.lowerLimit && scope.row.lowerLimit.toFixed(1) }}</span>
      </template>
      <template #meixiaoshibiaozhunhaodianshangxian="scope">
        <span>{{ scope.row.upperLimit && scope.row.upperLimit.toFixed(1) }}</span>
      </template>
      <template #shijihaodian="scope">
        <span>{{ scope.row.actualValue && scope.row.actualValue.toFixed(1) }}</span>
      </template>
      <template #shifouchaochushangxiaxian="scope">
        <div>
          <el-tag v-if="scope.row.exceedLimit" type="danger">{{ $t('shi') }}</el-tag>
          <el-tag v-else type="success">{{ $t('fou') }}</el-tag>
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import dayjs from 'dayjs';
// 生成昨天零点
const yesterdayZero = dayjs()
  .subtract(1, 'day')
  .startOf('day')
  .valueOf();
// 生成明天零点
const tomorrowZero = dayjs()
  .add(1, 'day')
  .startOf('day')
  .valueOf();

export default {
  name: 'web_customize_yongxin_energy_management_alarm_report_list',
  data() {
    return {
      conditions: {
        start: yesterdayZero,
        end: tomorrowZero
      },
      exceedLimit: [
        {
          label: 'shi',
          value: true
        },
        {
          label: 'fou',
          value: false
        }
      ],
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentInfo.name'
        },
        {
          label: 'tongjikaishishijian',
          prop: 'startTime',
          type: 'time'
        },
        {
          label: 'tongjijieshushijian',
          prop: 'endTime',
          type: 'time'
        },
        {
          label: 'meixiaoshibiaozhunhaodianxiaxian',
          prop: 'lowerLimit',
          type: 'slot'
        },
        {
          label: 'meixiaoshibiaozhunhaodianshangxian',
          prop: 'upperLimit',
          type: 'slot'
        },
        {
          label: 'shijihaodian',
          prop: 'actualValue',
          type: 'slot'
        },
        {
          label: 'shifouchaochushangxiaxian',
          prop: 'exceedLimit',
          type: 'slot'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 重置
    reset() {
      this.yt.clear(this.conditions);
    },
    // 新增之前处理数据
    beforeShowEditDialogInsert(row) {
      return row;
    },

    // 编辑之前处理数据
    beforeShowEditDialogEdit(row) {
      return row;
    }
  }
};
</script>
